import { BaseHttpService } from './base-http.service'

export default new (class AuthService extends BaseHttpService {
    getListStores(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
    getStoreDetail(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
    createOrUpdateStore(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
    deleteStore(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }

    getListStoreByRole(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
})()